/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ModeOfTransportationModelODataResultCollection } from "../models";
/**
 * ModeOfTransportationApi - axios parameter creator
 * @export
 */
export const ModeOfTransportationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiModeOfTransportationGet: async (
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/ModeOfTransportation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ModeOfTransportationApi - functional programming interface
 * @export
 */
export const ModeOfTransportationApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    ModeOfTransportationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiModeOfTransportationGet(
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ModeOfTransportationModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiModeOfTransportationGet(
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ModeOfTransportationApi - factory interface
 * @export
 */
export const ModeOfTransportationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ModeOfTransportationApiFp(configuration);
  return {
    /**
     *
     * @param {ModeOfTransportationApiApiModeOfTransportationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiModeOfTransportationGet(
      requestParameters: ModeOfTransportationApiApiModeOfTransportationGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<ModeOfTransportationModelODataResultCollection> {
      return localVarFp
        .apiModeOfTransportationGet(
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiModeOfTransportationGet operation in ModeOfTransportationApi.
 * @export
 * @interface ModeOfTransportationApiApiModeOfTransportationGetRequest
 */
export interface ModeOfTransportationApiApiModeOfTransportationGetRequest {
  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof ModeOfTransportationApiApiModeOfTransportationGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof ModeOfTransportationApiApiModeOfTransportationGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof ModeOfTransportationApiApiModeOfTransportationGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof ModeOfTransportationApiApiModeOfTransportationGet
   */
  readonly $orderby?: string;
}

/**
 * ModeOfTransportationApi - object-oriented interface
 * @export
 * @class ModeOfTransportationApi
 * @extends {BaseAPI}
 */
export class ModeOfTransportationApi extends BaseAPI {
  /**
   *
   * @param {ModeOfTransportationApiApiModeOfTransportationGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModeOfTransportationApi
   */
  public apiModeOfTransportationGet(
    requestParameters: ModeOfTransportationApiApiModeOfTransportationGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return ModeOfTransportationApiFp(this.configuration)
      .apiModeOfTransportationGet(
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
